<div>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="horizontal">
      <div>
        <ul class="languages">
          <li *ngFor="let language of languageService.getLanguages()"
              [ngClass]="{ 'active' : this.langId == language.id}"
              (click)="switchLanguage(language.id)">{{languageService.displayLanguage(language)}}
          </li>
        </ul>
      </div>
      <div class="vertical">
        <div class="vertical">
          <input type="text" formControlName="code" id="code" autocomplete="off"
                 placeholder="{{'app.alarm.code' | translate}}"
                 [ngClass]="{ 'invalid': submitted && fg.code.errors }"/>

          <div *ngIf="submitted && fg.code.errors">
            <div *ngIf="fg.code.errors.required" translate>app.alarm.code.empty.error</div>
          </div>
        </div>

        <div class="vertical">
          <label for="type" translate>app.alarm.type</label>
          <select formControlName="type" id="type">
            <option *ngFor="let type of alarmTypeService.getTypes()"
                    [value]="type.id" [hidden]="type.system">{{type.name}}</option>
          </select>
        </div>

        <br/>

        <ul class="levels">
          <li *ngFor="let level of alarmLevelService.getLevels()"
              [ngClass]="{ 'active' : this.levelId == level.id}"
              [hidden]="level.system" (click)="switchLevel(level.id)">{{level.name}}</li>
        </ul>

        <div>
          <div class="vertical">
            <input type="text" formControlName="title" id="title" autocomplete="off"
                   placeholder="{{'app.alarm.title' | translate}}"
                   [ngClass]="{ 'invalid': submitted && fg.title.errors }"
                   (input)="renderer(this.levelId, this.langId, true)"/>

            <div *ngIf="submitted && fg.title.errors">
              <div *ngIf="fg.title.errors.required" translate>app.alarm.title.empty.error</div>
            </div>
          </div>

          <br/>

          <div class="vertical">
              <textarea type="text" formControlName="text" id="text"
                        rows="10"
                        placeholder="{{'app.alarm.text' | translate}}"
                        [ngClass]="{ 'invalid': submitted && fg.text.errors }"
                        (input)="renderer(this.levelId, this.langId, true)"></textarea>

            <div *ngIf="submitted && fg.text.errors">
              <div *ngIf="fg.text.errors.required" translate>app.alarm.text.empty.error</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>

    <button [disabled]="loading" translate>app.alarm.create.button</button>
    <div *ngIf="error">{{error}}</div>
  </form>
</div>
